import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request whose failure the caller handles itself, so httpInterceptor must not raise
 * the global error toast for it. A 401 still clears the session as usual.
 *
 * Used by:
 * - the payment response page, which shows its own message for every error;
 * - the Pebbl product card lookup: a card that cannot be resolved is dropped and logged,
 *   and a toast over the chat for imagery the customer never asked for would read as a fault.
 * - the address popup's Address Type preview: it only backs a hint, and the save that follows
 *   runs the same check, so a failed preview shows "checked when saved" instead of a toast.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
